import { render, staticRenderFns } from "./ConfirmationBasketRefresh.vue?vue&type=template&id=c746b15a"
import script from "./ConfirmationBasketRefresh.vue?vue&type=script&lang=js"
export * from "./ConfirmationBasketRefresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports